/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type HTTPValidationError,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
} from '../models/HTTPValidationError';
import {
    type UploadBatchCreateRequest,
    UploadBatchCreateRequestFromJSON,
    UploadBatchCreateRequestToJSON,
} from '../models/UploadBatchCreateRequest';
import {
    type UploadBatchCreateResponse,
    UploadBatchCreateResponseFromJSON,
    UploadBatchCreateResponseToJSON,
} from '../models/UploadBatchCreateResponse';
import {
    type UploadBatchFinalizeRequest,
    UploadBatchFinalizeRequestFromJSON,
    UploadBatchFinalizeRequestToJSON,
} from '../models/UploadBatchFinalizeRequest';
import {
    type UploadBatchFinalizeResponse,
    UploadBatchFinalizeResponseFromJSON,
    UploadBatchFinalizeResponseToJSON,
} from '../models/UploadBatchFinalizeResponse';
import {
    type UploadBatchGetRequest,
    UploadBatchGetRequestFromJSON,
    UploadBatchGetRequestToJSON,
} from '../models/UploadBatchGetRequest';
import {
    type UploadBatchGetResponse,
    UploadBatchGetResponseFromJSON,
    UploadBatchGetResponseToJSON,
} from '../models/UploadBatchGetResponse';
import {
    type UploadBatchListResponse,
    UploadBatchListResponseFromJSON,
    UploadBatchListResponseToJSON,
} from '../models/UploadBatchListResponse';
import {
    type UploadLoginStartRequest,
    UploadLoginStartRequestFromJSON,
    UploadLoginStartRequestToJSON,
} from '../models/UploadLoginStartRequest';
import {
    type UploadLoginVerifyRequest,
    UploadLoginVerifyRequestFromJSON,
    UploadLoginVerifyRequestToJSON,
} from '../models/UploadLoginVerifyRequest';
import {
    type UploadLoginVerifyResponse,
    UploadLoginVerifyResponseFromJSON,
    UploadLoginVerifyResponseToJSON,
} from '../models/UploadLoginVerifyResponse';
import {
    type UploadMeResponse,
    UploadMeResponseFromJSON,
    UploadMeResponseToJSON,
} from '../models/UploadMeResponse';
import {
    type UploadsSetEnabledRequest,
    UploadsSetEnabledRequestFromJSON,
    UploadsSetEnabledRequestToJSON,
} from '../models/UploadsSetEnabledRequest';
import {
    type UploadsStatusResponse,
    UploadsStatusResponseFromJSON,
    UploadsStatusResponseToJSON,
} from '../models/UploadsStatusResponse';

export interface CreateBatchRequest {
    /**
     * 
     */
    uploadBatchCreateRequest: UploadBatchCreateRequest;
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface FinalizeBatchRequest {
    /**
     * 
     */
    uploadBatchFinalizeRequest: UploadBatchFinalizeRequest;
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface GetBatchRequest {
    /**
     * 
     */
    uploadBatchGetRequest: UploadBatchGetRequest;
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface ListBatchesRequest {
    /**
     * 
     */
    body: object;
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface SetUploadEnabledRequest {
    /**
     * 
     */
    uploadsSetEnabledRequest: UploadsSetEnabledRequest;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface UploadLoginStartOperationRequest {
    /**
     * 
     */
    uploadLoginStartRequest: UploadLoginStartRequest;
}

export interface UploadLoginVerifyOperationRequest {
    /**
     * 
     */
    uploadLoginVerifyRequest: UploadLoginVerifyRequest;
}

export interface UploadMeRequest {
    /**
     * 
     */
    uploadToken?: string | null;
    /**
     * 
     */
    accessToken?: string | null;
}

export interface UploadStatusRequest {
    /**
     * 
     */
    body: object;
    /**
     * 
     */
    accessToken?: string | null;
}

/**
 * 
 */
export class UploadApi extends runtime.BaseAPI {

    /**
     * Creates request options for createBatch without sending the request
     */
    async createBatchRequestOpts(requestParameters: CreateBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadBatchCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadBatchCreateRequest',
                'Required parameter "uploadBatchCreateRequest" was null or undefined when calling createBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/batches/create`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadBatchCreateRequestToJSON(requestParameters['uploadBatchCreateRequest']),
        };
    }

    /**
     * Create Batch
     */
    async createBatchRaw(requestParameters: CreateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchCreateResponse>> {
        const requestOptions = await this.createBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchCreateResponseFromJSON(jsonValue));
    }

    /**
     * Create Batch
     */
    async createBatch(requestParameters: CreateBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchCreateResponse> {
        const response = await this.createBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for finalizeBatch without sending the request
     */
    async finalizeBatchRequestOpts(requestParameters: FinalizeBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadBatchFinalizeRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadBatchFinalizeRequest',
                'Required parameter "uploadBatchFinalizeRequest" was null or undefined when calling finalizeBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/batches/finalize`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadBatchFinalizeRequestToJSON(requestParameters['uploadBatchFinalizeRequest']),
        };
    }

    /**
     * Finalize Batch
     */
    async finalizeBatchRaw(requestParameters: FinalizeBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchFinalizeResponse>> {
        const requestOptions = await this.finalizeBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchFinalizeResponseFromJSON(jsonValue));
    }

    /**
     * Finalize Batch
     */
    async finalizeBatch(requestParameters: FinalizeBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchFinalizeResponse> {
        const response = await this.finalizeBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getBatch without sending the request
     */
    async getBatchRequestOpts(requestParameters: GetBatchRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadBatchGetRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadBatchGetRequest',
                'Required parameter "uploadBatchGetRequest" was null or undefined when calling getBatch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/batches/get`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadBatchGetRequestToJSON(requestParameters['uploadBatchGetRequest']),
        };
    }

    /**
     * Get Batch
     */
    async getBatchRaw(requestParameters: GetBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchGetResponse>> {
        const requestOptions = await this.getBatchRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchGetResponseFromJSON(jsonValue));
    }

    /**
     * Get Batch
     */
    async getBatch(requestParameters: GetBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchGetResponse> {
        const response = await this.getBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listBatches without sending the request
     */
    async listBatchesRequestOpts(requestParameters: ListBatchesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling listBatches().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/batches/list`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * List Batches
     */
    async listBatchesRaw(requestParameters: ListBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadBatchListResponse>> {
        const requestOptions = await this.listBatchesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadBatchListResponseFromJSON(jsonValue));
    }

    /**
     * List Batches
     */
    async listBatches(requestParameters: ListBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadBatchListResponse> {
        const response = await this.listBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setUploadEnabled without sending the request
     */
    async setUploadEnabledRequestOpts(requestParameters: SetUploadEnabledRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadsSetEnabledRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadsSetEnabledRequest',
                'Required parameter "uploadsSetEnabledRequest" was null or undefined when calling setUploadEnabled().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/admin/set-enabled`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadsSetEnabledRequestToJSON(requestParameters['uploadsSetEnabledRequest']),
        };
    }

    /**
     * Set Upload Enabled
     */
    async setUploadEnabledRaw(requestParameters: SetUploadEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadsStatusResponse>> {
        const requestOptions = await this.setUploadEnabledRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadsStatusResponseFromJSON(jsonValue));
    }

    /**
     * Set Upload Enabled
     */
    async setUploadEnabled(requestParameters: SetUploadEnabledRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadsStatusResponse> {
        const response = await this.setUploadEnabledRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLoginStart without sending the request
     */
    async uploadLoginStartRequestOpts(requestParameters: UploadLoginStartOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadLoginStartRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadLoginStartRequest',
                'Required parameter "uploadLoginStartRequest" was null or undefined when calling uploadLoginStart().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/login/start`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadLoginStartRequestToJSON(requestParameters['uploadLoginStartRequest']),
        };
    }

    /**
     * Upload Login Start
     */
    async uploadLoginStartRaw(requestParameters: UploadLoginStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.uploadLoginStartRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload Login Start
     */
    async uploadLoginStart(requestParameters: UploadLoginStartOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.uploadLoginStartRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLoginVerify without sending the request
     */
    async uploadLoginVerifyRequestOpts(requestParameters: UploadLoginVerifyOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['uploadLoginVerifyRequest'] == null) {
            throw new runtime.RequiredError(
                'uploadLoginVerifyRequest',
                'Required parameter "uploadLoginVerifyRequest" was null or undefined when calling uploadLoginVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/login/verify`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UploadLoginVerifyRequestToJSON(requestParameters['uploadLoginVerifyRequest']),
        };
    }

    /**
     * Upload Login Verify
     */
    async uploadLoginVerifyRaw(requestParameters: UploadLoginVerifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadLoginVerifyResponse>> {
        const requestOptions = await this.uploadLoginVerifyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadLoginVerifyResponseFromJSON(jsonValue));
    }

    /**
     * Upload Login Verify
     */
    async uploadLoginVerify(requestParameters: UploadLoginVerifyOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadLoginVerifyResponse> {
        const response = await this.uploadLoginVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadLogout without sending the request
     */
    async uploadLogoutRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/upload/logout`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Upload Logout
     */
    async uploadLogoutRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.uploadLogoutRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Upload Logout
     */
    async uploadLogout(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.uploadLogoutRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadMe without sending the request
     */
    async uploadMeRequestOpts(requestParameters: UploadMeRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/upload/me`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Upload Me
     */
    async uploadMeRaw(requestParameters: UploadMeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadMeResponse>> {
        const requestOptions = await this.uploadMeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadMeResponseFromJSON(jsonValue));
    }

    /**
     * Upload Me
     */
    async uploadMe(requestParameters: UploadMeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadMeResponse> {
        const response = await this.uploadMeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for uploadStatus without sending the request
     */
    async uploadStatusRequestOpts(requestParameters: UploadStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling uploadStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/upload/admin/status`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        };
    }

    /**
     * Upload Status
     */
    async uploadStatusRaw(requestParameters: UploadStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UploadsStatusResponse>> {
        const requestOptions = await this.uploadStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UploadsStatusResponseFromJSON(jsonValue));
    }

    /**
     * Upload Status
     */
    async uploadStatus(requestParameters: UploadStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UploadsStatusResponse> {
        const response = await this.uploadStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
